import { useState } from 'react';
import { Popover } from '@headlessui/react';
import { usePopper } from 'react-popper';

function InfoPopover(props) {

	const [referenceElement, setReferenceElement] = useState();
	const [popperElement, setPopperElement] = useState();
	const [arrowElement, setArrowElement] = useState(null);
	const { styles, attributes } = usePopper(referenceElement, popperElement, {
		placement: 'right',
		strategy: 'fixed',
		modifiers: [{ name: 'arrow', options: { element: arrowElement } }],
	});

	return (
		<Popover className="relative text-sm" ref={setReferenceElement}>
	    	<Popover.Button>
	    		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
  					<path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
				</svg>
			</Popover.Button>

			<Popover.Panel className="absolute z-1000 bg-gray-50 w-60 rounded-lg shadow ml-2 p-1 text-left" ref={setPopperElement} style={styles.popper} {...attributes.popper}>
				<p>{props.content}</p>
				<div ref={setArrowElement} style={styles.arrow} className="absolute z-10 -ml-3 w-0 h-0 border-t-8 border-t-transparent border-r-8 border-r-gray-100 border-b-8 border-b-transparent" />
			</Popover.Panel>
			
	    </Popover>
	)
}

export default InfoPopover;